import { render, staticRenderFns } from "./StatInspItemFilter.vue?vue&type=template&id=b11c6c20"
import script from "./StatInspItemFilter.vue?vue&type=script&lang=js"
export * from "./StatInspItemFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports